import script from "./ParentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentForm.vue?vue&type=script&setup=true&lang=js"

import "./ParentForm.vue?vue&type=style&index=0&id=2d6cb2c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d6cb2c2"]])

export default __exports__